/*
 Copyright (c) 2018 Wells Fargo. 45 Fremont St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Jeremy Levy

 Description:
 */
export var CMS_REQUEST_START = 'CMS_REQUEST_START';
export var CMS_SET_DATA = 'CMS_SET_DATA';
export var CMS_REQUEST_END = 'CMS_REQUEST_END'; // INFO - assuming we would want to fetch data by a single id or by multiple ids
// ids: ['id-123', 'id-456']

export var cmsRequestStart = function cmsRequestStart(_ref) {
  var ids = _ref.ids,
      url = _ref.url;
  return {
    type: CMS_REQUEST_START,
    ids: ids,
    url: url
  };
};
export var cmsSetData = function cmsSetData(_ref2) {
  var ids = _ref2.ids,
      data = _ref2.data;
  return {
    type: CMS_SET_DATA,
    data: data,
    ids: ids
  };
};
export var cmsRequestEnd = function cmsRequestEnd(_ref3) {
  var ids = _ref3.ids;
  return {
    type: CMS_REQUEST_END,
    ids: ids
  };
};